var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticClass:"transparent-popup",model:{value:(_vm.showImg),callback:function ($$v) {_vm.showImg=$$v},expression:"showImg"}},[_c('div',{staticClass:"v-pop-img"},[_c('div',{staticClass:"content",on:{"click":_vm.close}},[_c('van-image',{staticClass:"img",attrs:{"src":_vm.imgUrl,"fit":"cover"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }